import { Component, OnInit ,ViewChild, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FDLMService } from '../../services/FDLM.Service';//SE IMPORTA EL SERVICIO
import { GetSoporteRQ, DocumentoSol } from '../../Interfaces';
import Swal from 'sweetalert2';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'visorPdf',
  templateUrl: './visorPdf.component.html'
})
export class visorPdfComponent implements OnInit {
  @ViewChild('pdfViewer', { static: false }) public pdfViewer;
  @Input() varDocumento: DocumentoSol;

 // public lverVisor: boolean;

  constructor(private http: HttpClient, private FDLMService: FDLMService,
    public snackbar: MatSnackBar,
    private spinner: NgxSpinnerService) {        
 }

  public ngOnInit() {
    if (this.varDocumento != null) {
      //this.lverVisor = false;
      this.cargaInfoVisor(this.varDocumento);
    }
  }

  public cargaInfoVisor(parDocumento: DocumentoSol) {
    this.spinner.show();
    this.varDocumento = parDocumento;
    //SE ENVIA A CARGAR INFORMACION DE CABEZOTE\
    var oGetSoporteRQ = <GetSoporteRQ>{
      parIdCabVer: this.varDocumento.tmpIdCabVer,
      parFormato: "PDF",
      parIdOrigen: 1 // 1.Visor
    }

    this.snackbar.open('Cargando Documento ...', '', { duration: 3000 });

    this.FDLMService.GetSoporte(oGetSoporteRQ).subscribe(
      (res) => {
        if (res.type != "application/json") {
          //this.lverVisor = true;
          this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
          this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf
        }
        else {
          //this.lverVisor = false;
          Swal.fire({ text: 'Error cargando el documento, verifique el formato', icon: 'warning', confirmButtonText: "Aceptar" });
          var msgRta = res;       
        }
        this.spinner.hide();
      },
      (err) => {
        //this.lverVisor = false;
        Swal.fire({ text: 'Error cargando el documento, verifique el formato', icon: 'warning', confirmButtonText: "Aceptar" });
        console.log(err);
        this.spinner.hide();
      });
  }

  private downloadFile(url: string): any {
    return this.http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }
}
